// import {PUBLIC_PRODUCT_FILTER_CONFIG} from './unit_edit_config_public.js'

const config = {
}

export default config;